var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.teacher)?_c('div',{key:_vm.teacher.id,staticClass:"d-flex flex-row align-center",on:{"click":function($event){return _vm.$emit('change', _vm.teacher)}}},[_c('v-avatar',{staticClass:"my-2 mr-2",attrs:{"size":"34"}},[_c('v-img',{attrs:{"src":_vm.avatar}})],1),_c('router-link',{staticClass:"teacher-link",attrs:{"to":_vm.getLink}},[_c('div',{staticClass:"teacher-name",class:{
        'teacher-link-disabled': ![
          'education_manager',
          'accountant',
          'manager',
          'super_admin'
        ].includes(_vm.role.type)
      }},[_vm._v("\n      "+_vm._s(_vm.teacher.name)+"\n    ")])])],1):_c('div',[_vm._v("Không có thông tin")])}
var staticRenderFns = []

export { render, staticRenderFns }